export enum SPLIT_TEXT {
  TASKS = "С какими задачами вам предстоит столкнуться:",
  EXPECTATION = "Мы ожидаем, что вы:",
  GIVE = "Что мы даем:",
  STAGES = "Коротко об этапах отбора:",
}
